import { useContext, useState } from "react";
import "./restaurant-inventory.styles.scss";
import { InventoryContext } from "../../../contexts/inventory.context";
import RIStock from "./restaurant-inventory-stock/ris.component";
import RIAddBox from "./resaurant-inventory-buylist/riaddbox.component";
import RIBuyItem from "./restaurant-inventory-item/ribuyitem.component";

const inventoryInitial = {
  name: "",
  toBuyDate: "",
  quantity: 0,
  unit: "Kilogram",
};

const RestaurantInventory = () => {
  const {
    inventoryContext,
    unitsContext,
    toBuyContext,
    addNewItem,
    updateItem,
    deleteFunction,
  } = useContext(InventoryContext);
  console.log(toBuyContext);
  const [inventoryAddFields, setInventoryAddFields] =
    useState(inventoryInitial);

  const [stockClass, setStockClass] = useState("ri-mobile-button active");
  const [toBuyClass, setToBuyClass] = useState("ri-mobile-button");
  const [currentPane, setCurrentPane] = useState("stock");
  const changePane = (pane) => {
    setCurrentPane(pane);
    if (pane === "stock") {
      setStockClass("ri-mobile-button active");
      setToBuyClass("ri-mobile-button");
    } else if (pane === "toBuy") {
      setStockClass("ri-mobile-button");
      setToBuyClass("ri-mobile-button active");
    }
  };
  const handleChange = (e) => {
    const { value, name } = e.target;
    setInventoryAddFields({ ...inventoryAddFields, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    addNewItem(inventoryAddFields);
  };
  const handleDelete = (index) => {
    deleteFunction(index);
  };

  const handleMoveToStock = (index) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    var mm = today.getMonth() + 1;
    var dd = today.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const formattedDate = dd + "/" + mm + "/" + yyyy;
    updateItem(index, formattedDate);
  };
  return (
    <div className="restaurant-inventory-container">
      {window.innerWidth > 1024 ? (
        <div className="restaurant-inventory-desktop">
          <div className="ri-stock-container">
            <div className="ri-stock-box">
              <span className="ri-stock-box-title">Available Stock</span>
              {Object.keys(inventoryContext).map((index) => {
                const tempObject = inventoryContext[index];

                return (
                  <RIStock
                    key={index}
                    tempObject={tempObject}
                    deleteFunction={handleDelete}
                    unitsObject={unitsContext}
                  />
                );
              })}
            </div>
          </div>
          <div className="ri-buylist-container">
            <div className="ri-buylist-box">
              <RIAddBox
                submitfunction={handleSubmit}
                changeFunction={handleChange}
                unitsObject={unitsContext}
                fields={inventoryAddFields}
              />
              <div className="ri-buylist">
                {Object.keys(toBuyContext).map((index) => {
                  const tempObject = toBuyContext[index];
                  return (
                    <RIBuyItem
                      key={index}
                      tempObject={tempObject}
                      handleDelete={handleDelete}
                      handleMoveToStock={handleMoveToStock}
                      unitsContext={unitsContext}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="restaurant-inventory-mobile">
          <div className="ri-mobile-buttons">
            <span className={stockClass} onClick={() => changePane("stock")}>
              Stock
            </span>
            <span className={toBuyClass} onClick={() => changePane("toBuy")}>
              To Buy
            </span>
          </div>
          {currentPane === "stock" ? (
            <div className="ri-stock-container">
              <div className="ri-stock-box">
                <span className="ri-stock-box-title">Available Stock</span>
                {Object.keys(inventoryContext).map((index) => {
                  const tempObject = inventoryContext[index];
                  return (
                    <RIStock
                      key={index}
                      tempObject={tempObject}
                      deleteFunction={handleDelete}
                      unitsObject={unitsContext}
                    />
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="ri-buylist-container">
              <div className="ri-buylist-box">
                <RIAddBox
                  submitfunction={handleSubmit}
                  changeFunction={handleChange}
                  unitsObject={unitsContext}
                  fields={inventoryAddFields}
                />
                <div className="ri-buylist">
                  {Object.keys(toBuyContext).map((index) => {
                    const tempObject = toBuyContext[index];
                    return (
                      <RIBuyItem
                        key={index}
                        tempObject={tempObject}
                        handleDelete={handleDelete}
                        handleMoveToStock={handleMoveToStock}
                        unitsContext={unitsContext}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default RestaurantInventory;
